export default __webpack_public_path__ + "static/media/mute-dark.14396283.svg";